package com.mgacreative.hotel.feature.hotel.ui.components

import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLAnchorElement

actual fun downloadDesktopExe() {
    window.open("https://github.com/gokhanazat/hotelos-releases/releases/latest/download/HotelOS.exe", "_blank")
}

actual fun openAndroidPlayStore() {
    window.open("https://play.google.com/store/apps/details?id=com.mgacreative.hotel", "_blank")
}
